/**=========================================================
 * Module: sync.js
 * Field Controller
 =========================================================*/

 App.controller('SyncController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'LocalRestangular', '$sce', '$interval', '$http',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, LR, $sce, $interval, $http) {
   "use strict";

   $scope.openExplorer = function(path){
       LR.one('explorer', path).get().then(function(){});
    }
    
    $scope.hasLanguageFolder = false;
   
    $scope.loadingLocalFiles = false;

    var byLang = function(files, lang){
        return files
            .filter((f) => { return f.path.replace(/[\d]*\.[^/.]+$/, '').toLowerCase().replace(/_/g,'-').endsWith('-'+lang.toLowerCase().replace(/_/g,'-')) })
    }
      
   $scope.loadLocalFiles = function (path) {
       if(path==CONFIG.folderSeparator) path = '' 
       if(!$scope.loadingLocalFiles){
        $scope.loadingLocalFiles = true;
        $scope.$emit('$syncEvent', {
            event: 'loading',
            scope: $scope
        })
        LR.one('files', $scope.code).get({
            folder: $scope.field.sync.folder,
            path: path
        }).then(function (resp) {
            $scope.loadingLocalFiles = false;
            var files = resp.files;
            $scope.field.localFolder = resp.paths;
            var emit = true
            if($scope.field.sync.lang && $scope.field.sync.lang==path){
                for(var k=0; k<$scope.field.localFolder.length; k++){
                    $scope.field.localFolder[k] += CONFIG.folderSeparator + $scope.field.sync.lang
                }
            }
            if ($scope.field.sync.lang && $scope.field.sync.lang!='*' && path=='') {
                //let newFiles = [];
                for (var i = 0; i < files.length; i++) {
                    if(files[i].isFolder && files[i].name==$scope.field.sync.lang){
                            $scope.currentFolder = CONFIG.folderSeparator + $scope.field.sync.lang
                            $scope.rootFolder = CONFIG.folderSeparator + $scope.field.sync.lang
                            $scope.hasLanguageFolder = true
                            $scope.loadLocalFiles($scope.field.sync.lang)
                            return
                            /*for(var k=0; k<$scope.field.localFolder.length; k++){
                                $scope.field.localFolder[k] += CONFIG.folderSeparator + $scope.field.sync.lang
                            }*/
                    }
                    
                    /*if (files[i].folder.startsWith(CONFIG.folderSeparator + $scope.field.sync.lang)) {
                        newFiles.push(files[i]);
                    }*/
                }
                /*if (newFiles.length == 0) {
                    for (var i = 0; i < files.length; i++) {
                        if (files[i].folder.startsWith(CONFIG.folderSeparator)) {
                            newFiles.push(files[i]);
                        }
                    }
                }
                files = newFiles;*/
            }
            $scope.field.localFiles = files;
            var projectIsMultiLang = $scope.model.destinations && $scope.model.destinations.length > 1
            if($scope.field.sync.upload){
                var showForUploadFiles = $scope.field.localFiles.filter($scope.showForUpload)
                var notAll = false
                if(!$scope.hasLanguageFolder && $scope.field.sync.lang && $scope.field.sync.lang!='*' && projectIsMultiLang){
                    let d = $rootScope.aqLanguageCode($scope.field.sync.lang)
                    //codice lingua xx_ZZ o xx_Yyyy_ZZ
                    //file che finiscono con codici memoQ
                    let langFiles = byLang(showForUploadFiles, $scope.field.sync.lang)
                    //file che finiscono con codice completo
                    langFiles = langFiles.concat(byLang(showForUploadFiles, d))
                    if(d.split('_').length>2){
                        //file che finiscono con _xx_Yyyy
                        langFiles = langFiles.concat(byLang(showForUploadFiles, d.split('_').slice(0, 2).join('_')))
                    }
                    //file che finiscono con _xx
                    langFiles = langFiles.concat(byLang(showForUploadFiles, d.split('_')[0]))
                    
                    //elimina path duplicati
                    langFiles = [...new Map(langFiles.map(item => [item['path'], item])).values()]
                    if(langFiles.length < showForUploadFiles.length){
                        notAll = true
                    }
                    showForUploadFiles = langFiles
                    
                }
                if(showForUploadFiles.filter(function(f) { return f.extension==='zip' }).length>0){
                    $scope.field.toBeUploaded = showForUploadFiles.filter(function(f) { return f.extension==='zip' }).map(function(f) { return f.path })
                    $scope.toggleToBeUploadedValue = false
                } else {
                    $scope.field.toBeUploaded = showForUploadFiles.map(function(f) { return f.path })
                    $scope.toggleToBeUploadedValue = !notAll
                }
            }
            var fl = function(f){
                if(!$scope.syncResult.unzipping && f.extension=='zip'){
                    FIREBASE.listen('unzip', f.md5, function(value){
                        if(value){
                            $timeout(function(){
                                f.unzipping = {}
                                f.unzipping.status = ''
                                if(value.success) f.unzipping.status = 'success'
                                if(value.errors) f.unzipping.status = 'error'
                                if(value.code>0) f.unzipping.status = 'error'
                                f.unzipping = Object.assign(f.unzipping, value)
                            }, 10)
                        }
                    }, null, { noRT: true, interval: 10000 })
                }
            }
            for(var i=0; i<$scope.field.localFiles.length; i++){
                fl($scope.field.localFiles[i])
            }

            if(emit){
                $scope.$emit('$syncEvent', {
                    event: 'loaded',
                    scope: $scope
                })
            }
        }).catch(function(err){
            $scope.loadingLocalFiles = false;
            //TODO gestione errore
            $scope.$emit('$syncEvent', {
                    event: 'error',
                    scope: $scope
                    })
            
        }); 
     }
       
   }

   $scope.toggleToBeUploaded = function(t){
        if(t.toggleToBeUploadedValue){
            $scope.field.toBeUploaded = $scope.field.localFiles.filter($scope.showForUpload).map(function(f) { return f.path })
        } else {
            $scope.field.toBeUploaded = []
        }
   }

   $scope.field.showLocalFilesToUpload = false;
        $scope.field.toggleShowLocalFilesToUpload = function($event, noLoad){
            if($event.stopPropagation)$event.stopPropagation();
            if($event.preventDefault)$event.preventDefault();
            $scope.field.showLocalFilesToUpload = !$scope.field.showLocalFilesToUpload;
            if($scope.field.showLocalFilesToUpload && !noLoad){
                $scope.loadLocalFiles($scope.currentFolder);
            }
        }
    
        $scope.syncingFromLocal = false;
        $scope.field.toBeUploaded = [];
        $scope.localFolderUpload = function($event){
            if($event.stopPropagation)$event.stopPropagation();
            if($event.preventDefault)$event.preventDefault();
            if($scope.field.toBeUploaded.length){
                $scope.syncingFromLocal = true;
                $scope.$emit('$syncEvent', {
                    event: 'uploading',
                    scope: $scope
                })
                LR.one('files','').customPUT({
                    bucket: $scope.field.bucket,
                    field: $scope.field.name,
                    entityId: $scope.form.model.id,
                    code: $scope.form.model.code || $scope.field.sync.code,
                    type: $scope.form.type,
                    folder: $scope.field.sync.folder,
                    files: $scope.field.toBeUploaded,
                    path: $scope.isRoot() ? '' : $scope.currentFolder
                }).then(function(resp){
                    $scope.syncingFromLocal = false;
                    $scope.field.toBeUploaded = [];
                    $scope.field.showLocalFilesToUpload = false;
                    var fn = function(s, r){
                        //$timeout(function(){
                            angular.element(document.getElementById('upload-fromlocal_'+s.field.name+'_'+(s.form.model.id || s.form.model.tempId)))
                                .triggerHandler('$uploadedFromLocal', r);
                            
                        //},1000)
                    }
                    fn($scope, resp)
                    $scope.$emit('$syncEvent', {
                        event: 'uploaded',
                        scope: $scope
                    })
                }).catch(function(err){
                    $scope.$emit('$syncEvent', {
                        event: 'error',
                        scope: $scope
                        })
                })
            } else {
                $scope.$emit('$syncEvent', {
                    event: 'nothingtoupload',
                    scope: $scope
                })
            }
        }

        $scope.$on('$automaticUpload', function(event, data){
            if(data.field === $scope.field.name 
                && data.type === $scope.form.type
                && data.modelId===$scope.form.model.id) {
                    $scope.field.toBeUploaded = data.files
                    $scope.localFolderUpload(event)
                }
        })
        if(!$rootScope.syncForms) $rootScope.syncForms = {}
        if($scope.form && $scope.form.model && $scope.field){
            $rootScope.syncForms[$scope.form.type+'_'+$scope.form.model.id+'_'+$scope.field.name] = true
        }

   $scope.localFolderUpdate = function($event){
        $event.stopPropagation();
        $event.preventDefault();
        $scope.loadLocalFiles($scope.currentFolder);
    }

   $scope.loadLocalFiles('');

   $scope.downloading = false;
   $scope.syncDownloadError = false;
   $scope.synced = false;
   $scope.syncResult = {}
   $scope.downloadFilesToLocal = function (files) {
       for(var i=0; i<files.length; i++){
           if(files[i].external){
               alert('La sincronizzazione non è possibile perché almeno uno dei file è un link esterno. Procedere con il download manuale.')
               return
           }
       }
       $scope.downloading = true;
       $scope.syncDownloadError = false;
       $scope.synced = false;
       $scope.$emit('$syncEvent', {
            event: 'downloading',
            scope: $scope
        })
       LR.one('files', '').customPOST({
           bucket: $scope.field.bucket,
           links: files.map(function (f) {
               return f.storageUrl;
           }),
           filenames: files.map(function(f){
               return f.name;
           }),
           folder: $scope.field.sync.folder,
           copyTo: $scope.field.sync.copyTo,
           doBackup: typeof $scope.field.sync.doBackup === 'string' ? $scope.field.sync.doBackup + '-' + new Date().toISOString().slice(0, 16).replace('T', '-').replace(':','-') : $scope.field.sync.doBackup,
           lang: $scope.hasLanguageFolder || $scope.field.sync.lang=='*' ? $scope.field.sync.lang : '',
           code: $scope.code,
           noUnzip: $scope.field.sync.noUnzip || false
       }).then(function (resp) {
           $scope.downloading = false
           $scope.synced = true
           $scope.syncResult = resp
           if($scope.syncResult.unzipping){
                $scope.$emit('$syncEvent', {
                    event: 'unzipping',
                    scope: $scope
                })
                var fl = function(k){
                    FIREBASE.listen('unzip', $scope.syncResult.unzipping[k].md5, function(value){
                        $timeout(function(){
                            for(var i=0; i<$scope.syncResult.unzipping.length; i++){
                                if(value && value.md5===$scope.syncResult.unzipping[i].md5){
                                    $scope.syncResult.unzipping[i].status = ''
                                    if(value.success) $scope.syncResult.unzipping[i].status = 'success'
                                    if(value.errors || value.code>0) $scope.syncResult.unzipping[i].status = 'error'
                                    $scope.syncResult.unzipping[i] = Object.assign($scope.syncResult.unzipping[i], value)
                                    if(value.end){
                                        if($scope.syncResult.unzipping[i].status == 'success'){
                                            if($scope.syncResult.unzipped.filter(function(u){ return u.file==$scope.syncResult.unzipping[i].file}).length==0){
                                                $scope.syncResult.unzipped.push({file:$scope.syncResult.unzipping[i].file})
                                            }
                                        } else {
                                            $scope.syncResult.unzipped = $scope.syncResult.unzipped.filter(function(u){ return u.file!=$scope.syncResult.unzipping[i].file})
                                        }
                                        $scope.loadLocalFiles($scope.currentFolder);
                                    }
                                    break;
                                }
                            }
                        }, 10)
                    }, null, { noRT: true, interval: 10000 })
                }
               for(var k in $scope.syncResult.unzipping){
                   $scope.syncResult.unzipping.status='';
                   fl(k)
               }
           }
           $timeout(function () {
               $scope.loadLocalFiles('');
           }, 100);
           $scope.$emit('$syncEvent', {
               event: 'downloaded',
               scope: $scope
           })

       }).catch(function (err) {
           $scope.syncDownloadError = true;
           $scope.synced = false
           $scope.downloading = false;
           $scope.syncResult = err.data
           $scope.$emit('$syncEvent', {
            event: 'error',
            scope: $scope
            })
       })
   }

   $scope.openUnzipReport = function(md5){
        $scope.unzipReport = ''
        $http({
            method: 'GET',
            url: 'https://storage.googleapis.com/' + $rootScope.bucketName() + '/unzip/'+md5+'.txt?t=' + new Date().getTime(),
            responseType: 'text/plain'
        }).then(function successCallback(response) {
            $scope.unzipReport = response.data
        });
        ngDialog.open({
            template: '/app/views/entities/unzip-report.html',
            className: 'ngdialog-theme-large ngdialog-theme-xlarge',
            scope: $scope,
            cache: false
        })
   }

   $scope.rootFolder = CONFIG.folderSeparator;
   $scope.currentFolder = CONFIG.folderSeparator;

   $scope.isRoot = function(){
     return $scope.currentFolder === CONFIG.folderSeparator;
   }

   $scope.showForUpload = function(f){
        if(f){
            if($scope.field.toBeUploaded && $scope.field.toBeUploaded.indexOf(f.name)>=0) return true;
            if($scope.field.allow){
                var allowed = $scope.field.allow.split('|')
                return !f.isFolder && allowed.indexOf(f.extension)>=0 && f.folder == $scope.currentFolder;
            } else {
                return !f.isFolder && f.folder == $scope.currentFolder;
            }
        }
    }
    $scope.showForUploadFolder = function(f){
        if(f){
                return f.isFolder && f.folder == $scope.currentFolder;
        }
    }

   $scope.showCurrentFolder = function (f) {
       return f.folder == $scope.currentFolder && !f.isFolder;
   }
   $scope.showUpperFolder = function (f) {
       return f.folder == $scope.currentFolder && f.isFolder;
   }
   $scope.showFolder = function (folder) {
       if (folder.indexOf(CONFIG.folderSeparator) !== 0) folder = CONFIG.folderSeparator + folder;
       $scope.currentFolder = !$scope.isRoot() ? $scope.currentFolder + folder : folder;
       $scope.loadLocalFiles($scope.currentFolder)
       $scope.field.toBeUploaded = [];
   }
   $scope.currentFolderUp = function (get) {
       var a = $scope.currentFolder.split(CONFIG.folderSeparator);
       var f = '';
       for (var i = 0; i < a.length - 1; i++) {
           if (f != CONFIG.folderSeparator) f += CONFIG.folderSeparator;
           f += a[i];
       }
       if (get) return f;
       else {
           $scope.currentFolder = f;
           $scope.loadLocalFiles($scope.currentFolder)
           $scope.field.toBeUploaded = [];
       }
   }

   $scope.$on('$destroy', function() {
       if($rootScope.syncForms && $scope.form && $scope.field){
            delete $rootScope.syncForms[$scope.form.type+'_'+$scope.form.model.id+'_'+$scope.field.name]
       }
   })

     
 }
 ]);